import cookies from 'js-cookie'
import { logout } from './user'

const KEY_MEET = 'mobile_score_meet'

export function getMeet() {
  const ssValue = sessionStorage.getItem(KEY_MEET)
  const lsValue = localStorage.getItem(KEY_MEET)
  const cookieValue = cookies.get(KEY_MEET) && decodeURI(cookies.get(KEY_MEET))
  const value = ssValue || lsValue || cookieValue
  if (!value) {
    logout('登录信息失效')
    return
  }
  if (!ssValue || !lsValue || !cookieValue) {
    setMeet(value)
  }
  return value
}

export function setMeet(value) {
  cookies.set(KEY_MEET, encodeURI(value), { expires: 7 })
  sessionStorage.setItem(KEY_MEET, value)
  localStorage.setItem(KEY_MEET, value)
}

export function removeMeet() {
  cookies.remove(KEY_MEET)
  localStorage.removeItem(KEY_MEET)
  sessionStorage.removeItem(KEY_MEET)
}
